/*DIVISION / ACTIVITY ASSIGNMENTS*/
Vue.component('divisionactivityassignments', {
    template:'#divisionactivityassignments-template',

    data:function(){
        return{
            divisions: [],
            activities: [],
            searchString:'',
            assignmentData:[],
            modal:'',
            head:'',
            tableHeight:'',
            tableOffset:'',
            activeDivisionId:10,
            activeDivision:{},
            filteredActivities:{},
            selectedActivityId: '-1'
        };
    },
    watch:{
        activeDivisionId:function(){
            activeInstance.selectedActivityId = -1;

            activeInstance.divisions.forEach(function(record){
                if(activeInstance.activeDivisionId == record.id){
                    activeInstance.activeDivision = record;
                }
            });
        }
    },
    created:function(){

        activeInstance = this;
        //activeInstance.modal = $('body').find('#create_user_modal').html();

        //GET ACTIVITIES WITH DIVISIONS
        showLoadingOverlay();
        Vue.http.get(baseURL+'/api/activities_with_divisions',function(response1){
            $('body').LoadingOverlay("hide");
            activeInstance.activities=response1;

            //GET DIVISIONS FOR THE TITLES
            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/company_divisions_with_activities',function(response2){
                $('body').LoadingOverlay("hide");
                activeInstance.divisions=response2;

                //GET ASSIGNMENTS
                showLoadingOverlay();
                Vue.http.get(baseURL+'/api/division_activity_assignments',function(response3){
                    $('body').LoadingOverlay("hide");
                    activeInstance.assignmentData=response3;

                    $.each(activeInstance.activities,function(index,activity){
                        $.each(activity.divisions ,function(index2,division){
                            $.each(activeInstance.assignmentData,function(index3,record){
                                if(division.id == record.division_id && activity.id==record.activity_id)
                                {
                                    //console.log(division.name+' has been selected for the '+activity.name);
                                    division.selected = 1;
                                }
                            });
                        })
                    });

                    activeInstance.divisions.sort(function(a, b){
                        if(a.title < b.title) return -1;
                        if(a.title > b.title) return 1;
                        return 0;
                    });

                    activeInstance.activeDivision = activeInstance.divisions[0];
                    activeInstance.activeDivisionId = activeInstance.divisions[0].id;



                }).bind(this);
            }).bind(this);


            setTimeout(function(){
                var $table = $('.fixed_header_table');
                $table.floatThead({
                    top:65
                });

               // $('.responsive-table').footable();

            },200);


        }).bind(this);
    },
    methods:{
        save:function(){
            showLoadingOverlay();
            Vue.http.post(baseURL+'/admin/division_activity_assignments/update',{activities:activeInstance.activities}).then(function(response){
                $('body').LoadingOverlay("hide");
                successNotification('A lista sikeresen frissítve.');
            });
        },
        nextDivision: function(){
            if(activeInstance.divisions.length>0){
                var options = $("#division_select").find("option");

                options.each(function(i, item) {
                    if (item.getAttribute('value') == activeInstance.activeDivisionId) {
                        if (options.length -1 == i) {
                            activeInstance.activeDivisionId = options[0].value;
                        } else {
                            activeInstance.activeDivisionId = options[i + 1].value;
                        }
                        return false;
                    }
                });
            }
        },
        previousDivision: function() {
            if (activeInstance.divisions.length>0) {
                var options = $("#division_select").find("option");

                options.each(function(i, item) {
                    if (item.getAttribute('value') == activeInstance.activeDivisionId) {
                        if (i == 0) {
                            console.log(1);
                            activeInstance.activeDivisionId = options[options.length -1].value;
                        } else {
                            activeInstance.activeDivisionId = options[i - 1].value;
                        }
                        return false;
                    }
                });
            }
        },
        insertActivity: function() {
            if (parseInt(activeInstance.selectedActivityId, 10) <= -1) {
                return;
            }

            var url = baseURL + '/admin/division_activity_assignments/insert';

            axios.post(url, {
                activity_id: activeInstance.selectedActivityId,
                division_id: activeInstance.activeDivisionId
            }).then(function(response) {

                activeInstance.divisions.forEach(function(item, i) {
                    if (item.id == activeInstance.activeDivisionId) {
                        item.activity_assignments.push(response.data);
                    }
                });

            }).catch(function(error) {
                console.log(error);
            });
        },
        removeActivity: function(assignment) {
            var url = baseURL + '/admin/division_activity_assignments/remove';

            bootbox.confirm({
                message: "Biztosan eltávolítod a(z) " + assignment.activity.name + " tevékenységet?",
                buttons: {
                    confirm: {
                        label: 'Igen',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Mégsem',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        axios.post(url, {assignment_id: assignment.id}).then(function(response) {

                            activeInstance.divisions.forEach(function(division) {
                                if (division.id == activeInstance.activeDivisionId) {
                                    division.activity_assignments = division.activity_assignments.filter(function(assignment_item) {
                                        return assignment_item.id != assignment.id;
                                    });
                                    return false;
                                }
                            });
                        }).catch(function(error) {
                            console.log(error);
                        });
                    }
                }
            });
        },
        filterActivitiesByDivision: function(activity){

            var result = false;

            $.each(activeInstance.activeDivision.activity_assignments,function(index,assignment){
                //console.log(assignment);
                if(assignment.activity.id == activity.id){
                    result = true;
                }
            });
            return result;
        }
    }
});
